import React from 'react';
import { motion } from 'framer-motion';

const variants = {
  initial:  { opacity: 0, y: 6 },
  animate:  { opacity: 1, y: 0 },
  exit:     { opacity: 0, y: -4 },
};

const transition: any = { duration: 0.15, ease: 'easeOut' };

export default function PageTransition({ children }: { children: React.ReactNode }) {
  return (
    <motion.div
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={transition}
      style={{ minHeight: '100vh' }}
    >
      {children}
    </motion.div>
  );
}
